import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';
import qs from 'qs';

// 获取生产单列表数据
export function getOrderList(data: any, query: any, hideLoading: any = false) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/queryList.ac`,
    method: 'post',
    params: query,
    data,
    hideLoading,
  });
}
// 获取生产单列表数据汇总
export function queryListExtra(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/queryListExtra.ac`,
    method: 'post',
    data,
    hideLoading: true,
  });
}
// 获取生产单列表数据汇总(同列表查询参数)
export function queryListExtraFullParams(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/queryListExtraFullParams.ac`,
    method: 'post',
    data,
    hideLoading: true,
  });
}
// 获取生产单列表数据(不校验权限)
export function getOrderListForChoose(
  data: Recordable,
  params: Recordable,
  hideLoading?: boolean
) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/listForChoose.ac`,
    method: 'post',
    params,
    data,
    hideLoading,
  });
}
// 提交生产单
export function approvalConfirm(data: any, noErrorToast?: boolean) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/approvalConfirm.ac`,
    method: 'post',
    data,
    noErrorToast,
  });
}

// 保存生产单草稿
export function saveDraft(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/saveDraft.ac`,
    method: 'post',
    data,
  });
}

// 保存生产单草稿-批量
export function batchSaveDraft(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/batchSaveDraft.ac`,
    method: 'post',
    data,
  });
}

// 保存生产单-批量
export function batchCreateProduceOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/batchCreateProduceOrder.ac`,
    method: 'post',
    data,
  });
}

// 查看生产单详情
export function getOrder(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/getOrder.ac`,
    method: 'post',
    params,
  });
}

// 查看生产单详情(safe会校验查看权限的二级权限)
export function safeGetOrder(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/safeGetOrder.ac`,
    method: 'post',
    params,
  });
}
// 查询生产组
export function listAllocation(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/workProcess/allocation/listAllocation.ac`,
    method: 'post',
    data,
  });
}

// 分配&领用记录
export function listAllocationRecord(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/workProcess/allocation/record/listAllocationRecord.ac`,
    method: 'post',
    data,
  });
}

// 删除分配、领用记录
export function deleteRecord(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/workProcess/allocation/record/deleteRecord.ac`,
    method: 'post',
    data,
  });
}

// 分配
export function workProcessAllocate(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/workProcess/allocation/allocate.ac`,
    method: 'post',
    data,
    noErrorPop: true,
  });
}

// 领用
export function workProcessPick(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/workProcess/allocation/pick.ac`,
    method: 'post',
    data,
    noErrorPop: true,
  });
}
// 检查工序操作权限
export function checkWorkProcessEditPermission(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/checkWorkProcessEditPermission.ac`,
    method: 'post',
    data,
  });
}

// 批量查看生产单详情
export function getMultiOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/multi/getOrder.ac`,
    method: 'post',
    data,
  });
}

// 重新计算
export function refreshStock(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/produce/material/data/refresh.ac`,
    method: 'post',
    data,
  });
}

// 获得临时占用库存
export function getMaterialOccupation(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/produce/material/data/list.ac`,
    method: 'post',
    data,
    params,
  });
}

// 获得生产单bom数据，用于用料中心-单品汇总去采购时获取物料数据
export function getProduceMaterialList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/produce/material/data/query/list.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data,
  });
}

// 批量更新
export function batchUpdateState(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/produce/material/data/batch/update/status.ac`,
    method: 'post',
    data,
  });
}

// 查询生产物料数据临时占用
export function getMaterialOccupationNumber(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/produce/material/data/query/list/orderSn.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data,
  });
}

// 获得生产单的物料下单数和裁床数
export function getMaterialOrderNumberAndCutBedNumber(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/getMaterialOrderNumberAndCutBedNumber.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data,
  });
}

// 查询外发单列表
export function queryOutwardList(data: any, query: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/queryList.ac`,
    method: 'post',
    params: query,
    data,
  });
}
// 查询外发单详情
export function getOrderDetail(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/getOrder.ac`,
    method: 'post',
    params,
  });
}
// 批量查询外发单详情和回收记录
export function batchGetOutwardOrderInfo(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/multiple/orderInfo.ac`,
    method: 'post',
    data,
  });
}

// 多单回收
export function batchRecoverSaveOutwardOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/multiple/recoverSave.ac`,
    method: 'post',
    data,
    noErrorPop: true,
  });
}

// 撤销外发单
export function destroyOutward(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/destroy.ac`,
    method: 'post',
    params,
  });
}

// 查询外发回收记录
export function queryRecoverList(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/queryRecoverList.ac`,
    method: 'post',
    params,
  });
}

// 修改外发加工单价
export function editOutwardPrice(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/editPrice.ac`,
    method: 'post',
    data,
  });
}

// 修改外发加工单价记录
export function pageEditPriceOperateRecord(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/pageEditPriceOperateRecord.ac`,
    method: 'post',
    data,
    params,
  });
}

export const saveWorkProcess = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/saveWorkProcess.ac`,
    method: 'post',
    data,
    noErrorPop: true,
  });
};
// 保存时校验已结算或者已支付
export function validateTicketReports(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/workTicket/getProduceOrderTicketReports.ac`,
    method: 'post',
    params,
  });
}

// 保存外发回收记录
export function recoverSave(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/recoverSave.ac`,
    method: 'post',
    data,
    noErrorPop: true,
  });
}

// 删除外发回收记录
export function recoverDelete(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/recoverDelete.ac`,
    method: 'post',
    params,
  });
}

// 生产工序汇报进度
export function workProcessReport(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/workProcessReport.ac`,
    method: 'post',
    data,
  });
}

// 生产工序汇报进度【多人汇报】
export function workProcessReportMultiUser(data: any, noErrorToast?: boolean) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/workProcessReportForMultiUser.ac`,
    method: 'post',
    data,
    noErrorToast,
  });
}

// 生产工序汇报进度 【多工序汇报】【多人汇报】
export function batchWorkProcessReportForMultiUser(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/batchWorkProcessReportForMultiUser.ac`,
    method: 'post',
    data,
  });
}

// 查询生产工序列表
export function selectWorkProcessList(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/selectWorkProcessList.ac`,
    method: 'post',
    params,
  });
}

// 查询生产单汇报记录
export function queryProduceReportList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/queryProduceReportList.ac`,
    method: 'post',
    data,
  });
}

// 新增外发工序
export function addOutsourceProcess(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/approvalConfirm.ac`,
    method: 'post',
    data,
  });
}

// 查询工序汇报记录
export function queryWorkProcessReportList(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/queryWorkProcessReportList.ac`,
    method: 'post',
    params,
  });
}

// 查询生产工序详情
export function getWorkProcessInfo(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/getWorkProcessInfo.ac`,
    method: 'post',
    params,
  });
}

// 生产工序汇报审核
export function reportReview(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/reportReview.ac`,
    method: 'post',
    data,
  });
}

// 生产工序汇报删除
export function reportDelete(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/reportDelete.ac`,
    method: 'post',
    params,
  });
}
// 扫菲汇报整体数量工序记录删除
export function deleteWorkProcessReportById(params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/workTicket/deleteWorkProcessReportById.ac`,
    method: 'post',
    params,
  });
}
// 生产工序汇报删除 多人
export function reportDeleteForMultiUser(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/reportDeleteForMultiUser.ac`,
    method: 'post',
    params,
  });
}

// 结束生产
export const produceFinish = (params: any, noErrorToast?: boolean) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/finish.ac`,
    method: 'post',
    params,
    noErrorToast,
  });
};
export const produceFinishes = (data: string[], params: any = {}) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/finishes.ac`,
    method: 'post',
    data,
    params,
  });
};

// 恢复生产
export const produceRenew = (ordersSn: string) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/renew.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
};

// 撤销
export const produceDestory = (ordersSn: string) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/destory.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
};
export const produceDestories = (data: string[]) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/destories.ac`,
    method: 'post',
    data,
  });
};

// 查询生产工序汇报审核记录
export function queryReportReviewList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/queryReportReviewList.ac`,
    method: 'post',
    data,
  });
}

// 获取商品选择物料
export const selectGoodsMaterial = (goodsId: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/selectGoodsMaterial.ac?goodsId=${goodsId}`,
    method: 'post',
  });
};

// 获取订单类型
export const isFirstProduceOrder = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/isFirstProduceOrder.ac`,
    method: 'post',
    params,
  });
};

// 获取订单类型列表
export const getProduceOrderTypeList = (data: any, params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/produce/order/type/getProduceOrderTypeList.ac`,
    method: 'post',
    data,
    params,
  });
};

// 删除生产单草稿
export const deleteDraft = (ordersSn: string) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/deleteDraft.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
};

// 编辑生产单
export const produceEdit = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/edit.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单交货日期
export const produceEditContractTime = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editContractTime.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单入库仓库
export const produceStorehouseEdit = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editStorehouse.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单预计开始时间
export const produceEditEstimateBeginTime = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editEstimateBeginTime.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单线上订单号
export const produceEditOnlineSn = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editOnlineSn.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单订单付款日期
export const produceEditPayTime = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editPayTime.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单预计交货时间
export const produceEditDeliveryTime = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editDeliveryTime.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单业务日期时间
export const produceEditBusinessTime = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editBusinessTime.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单生产部门
export const editProduceDepartment = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editProduceDepartment.ac`,
    method: 'post',
    data,
  });
};
// 编辑生产单生产负责人
export const editProduceManager = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editProduceManager.ac`,
    method: 'post',
    data,
  });
};

// 分页查询生产报表
export const queryStatisticsList = (data: any, params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/statistics/produce/queryStatisticsList.ac`,
    method: 'post',
    data,
    params,
  });
};
// 分页查询生产报表
export const queryTotalStatistics = (data: any, params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/statistics/produce/queryTotalStatistics.ac`,
    method: 'post',
    data,
    params,
  });
};
// 查询进销存是否开启出入库功能
export const getIsCompanyConfig = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/is/getIsCompanyConfig.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data),
  });
};

// 分页查询生产单的出货天数报表
export const queryOutDaysStatisticsList = (params: any, data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/statistics/produce/queryOutDaysStatisticsList.ac`,
    method: 'post',
    data,
    params,
  });
};

// 分页查询生产单的出货天数报表汇总
export const queryOutDaysStatisticsListCollect = (params: any, data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/statistics/produce/queryOutDaysStatisticsListCollect.ac`,
    method: 'post',
    data,
    params,
  });
};

// 查询生产单的出货天数报表总数
export const queryTotalOutDaysStatistics = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/statistics/produce/queryTotalOutDaysStatistics.ac`,
    method: 'post',
    data,
  });
};
// 生产单查询进销存采购单信息
export const getIsPurchaseOrder = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/getIsPurchaseOrder.ac`,
    method: 'post',
    params,
  });
};

export const checkReportIsSettle = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/checkReportIsSettle.ac`,
    method: 'post',
    params,
  });
};
// 获取生产单列表的采购进度表
export const listMaterial = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/listMaterial.ac`,
    method: 'post',
    params,
  });
};
// 获取默认生产批次
export function getProduceBatchSn(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/generateProduceBatchSn.ac`,
    method: 'post',
    data,
  });
}
// 获取默认生产批次（批量）
export function generateProduceBatchSns(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/generateProduceBatchSns.ac`,
    method: 'post',
    data,
  });
}
// 获取生产单列表的发料进度表
export const getIssueMaterialList = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/getIssueMaterialList.ac`,
    method: 'post',
    params,
  });
};
// 更新物料单品齐料状态
export const updateIsCompleteBySkuIds = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/updateIsCompleteBySkuIds.ac`,
    method: 'post',
    data,
  });
};
// 生产单bom-更新物料单品发料状态
export const editMaterialIssueState = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editMaterialIssueState.ac`,
    method: 'post',
    data,
  });
};
// 更新物料单品备注
export const updateMtRemarkBySkuIds = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editMaterialRemark.ac`,
    method: 'post',
    data,
  });
};
// 编辑加工费模板
export const editProcessFeeTemplate = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/processFeeTemplate/edit/default.ac`,
    method: 'post',
    data,
  });
};
// 获取加工费模板
export const getProcessFeeTemplate = (data?: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/processFeeTemplate/get/default.ac`,
    method: 'post',
    data,
  });
};

// 加工费审核
export const approvalProcessFeeAudit = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/approvalProcess/processFee/audit.ac`,
    method: 'post',
    data,
  });
};
// 提交审核（待提交 -> 待审核）
export const submitProcessFeeAudit = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/approvalProcess/processFee/audit/submit.ac`,
    method: 'post',
    params,
  });
};
// 撤销审核（同意 -> 待提交）
export const destoryProcessFeeAudit = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/approvalProcess/processFee/audit/destory.ac`,
    method: 'post',
    params,
  });
};
// 取消审核（待审核 -> 待提交）
export const cancelProcessFeeAudit = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/approvalProcess/processFee/audit/cancel.ac`,
    method: 'post',
    params,
  });
};

// 流程审核流水-根据流程id
export function querylogList(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/approvalProcess/processFee/listRecord.ac`,
    method: 'post',
    params,
  });
}

export const startProcessFeeAudit = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/approvalProcess/processFee/audit/startForProduceOrder.ac`,
    method: 'post',
    params,
  });
};

// 根据materialSkuId、加工厂id换取加工厂当前库存、可用库存
export const listMaterialStoredByFactoryId = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/material/stored/listMaterialStoredByFactoryId.ac`,
    method: 'post',
    data,
  });
};

// 获取生产单成本核算数据

export const getGoodsCostByCondition = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/getGoodsCostByCondition.ac`,
    method: 'post',
    params,
  });
};
// 查询所有工作名称列表
export const queryAllWorkProcessNameList = (
  params?: Recordable & PageParams,
  data?: Recordable[]
) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/listAllWorkProcessName.ac`,
    method: 'post',
    data,
    params,
  });
};

// 同步工序-检验
export const getSyncParamCheckResult = (data: Recordable) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/workProcess/getSyncParamCheckResult.ac`,
    method: 'post',
    data,
  });
};

// 同步工序
export const syncWorkProcesses = (data: Recordable) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/workProcess/sync.ac`,
    method: 'post',
    data,
  });
};

// 通过商品ID查询工序名称
export const listWorkProcessByGoodsId = (goodsId: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/listWorkProcess.ac?goodsId=${goodsId}`,
    method: 'post',
  });
};

// 通过生产单单号查询工序名称
export const listWorkProcessByOrdersSn = (ordersSn: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/listWorkProcess.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
};

// 外发回收审核
export function recoverAudit(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/recover/audit.ac`,
    method: 'post',
    data,
    noErrorPop: true,
  });
}

// 查询外发回收审核记录
export function queryAuditRecoverRecordList(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/recover/audit/record/getLast.ac`,
    method: 'post',
    params,
  });
}

// 生产单物料清单bom锁定/解锁
export function editBomStateByProduceOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editBomState.ac`,
    method: 'post',
    data,
  });
}

// 生产单物料清单bom完成状态
export function editBomFinishByProduceOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/editBomFinish.ac`,
    method: 'post',
    data,
  });
}
// 校验是否存在生产单关联的物料采购单
export function checkHasMaterialPurchase(ordersSn: string) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/checkHasMaterialPurchase.ac?ordersSn=${ordersSn}`,
    method: 'post',
  });
}

// 查询生产单关联的物料单件用量等信息
export function getMaterialPerUseNumber(ordersSn: string) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/getMaterialPerUseNumber.ac?orderSn=${ordersSn}`,
    method: 'get',
  });
}

// 生产单-修改优先生产
export function approvalPriorityConfirm(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/approvalPriorityConfirm.ac`,
    method: 'post',
    data,
  });
}

// 外发回收记录列表
export function queryOutwardRecoverList(
  data: any,
  query: any,
  hideLoading: false
) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/recover/queryList.ac`,
    method: 'post',
    params: query,
    data,
    hideLoading,
  });
}
// 外发回收记录导出列表
export function queryOutwardExportRecoverList(
  data: Recordable,
  query: Recordable,
  hideLoading: false
) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/recover/exportList.ac`,
    method: 'post',
    params: query,
    data,
    hideLoading,
  });
}
// 外发回收记录详情
export function getOutwardRecoverDetail(id: number) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/recover/getRecover.ac?id=${id}`,
    method: 'post',
  });
}

// 获取上一次新增生产单时选择的订单类型、入库仓库
export function getLastProduceOrderInfo() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/getLastOrderInfo.ac`,
    method: 'get',
  });
}

// 生产单导入报价单
export function importProduceQuotationOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/importQuotationOrder.ac`,
    method: 'post',
    data,
  });
}

// 修改下单数
export function adjustProduceOrderNumber(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/adjust/number.ac`,
    method: 'post',
    data,
  });
}
export function editAttachmentList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/attachment/save.ac`,
    method: 'post',
    data,
  });
}

// 获取裁床汇报审核数据明细
export function listReportNumber(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/listReportNumber.ac`,
    method: 'post',
    data,
  });
}

// 标记财审
export function markOutwardFinanceAudit(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/finance/audit.ac`,
    method: 'post',
    data,
  });
}
// 批量计划单、请求单创建生产单
export function batchCreateProduceOrderV2(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/batchCreateProduceOrderV2.ac`,
    method: 'post',
    data,
  });
}

// 批量计划单、请求单创建生产单草稿
export function batchSaveDraftV2(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/batchSaveDraftV2.ac`,
    method: 'post',
    data,
  });
}

// 批量编辑休息日
export function batchEditRestDays(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/scheduling/holiday/batch-edit.ac`,
    method: 'post',
    data,
  });
}

// 查询休息日
export function queryRestDays(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/scheduling/holiday/month.ac`,
    method: 'post',
    data,
  });
}

// 检查生产单是否可以拆单 false 代表没有占用可以拆 true 代表有关联的单据不可以拆
export function checkProduceOrderSplit(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/check/split.ac`,
    method: 'post',
    data,
  });
}

// 生产单拆单
export function splitProduceOrder(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/split/order.ac`,
    method: 'post',
    data,
  });
}

// 自动排产
export function getAutoSchedulingPlan(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/scheduling/getPlan.ac`,
    method: 'post',
    data,
  });
}

// 获取排产记录
export function getSchedulingData(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/scheduling/factory-date-range.ac`,
    method: 'post',
    data,
  });
}

// 保存排产记录
export function saveSchedulingRecord(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/scheduling/batch-edit.ac`,
    method: 'post',
    data,
  });
}

// 节点审核日志
export function auditFlowOperateLog(data: Recordable, params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/workProcess/auditFlow/pageOperateLog.ac`,
    method: 'post',
    data,
    params,
  });
}

// 加工单详情
export function getProcessOrderDetail(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/outward/process/recover/material/getByOrdersSn.ac`,
    method: 'post',
    params,
  });
}
